import * as React from 'react'
import { routerActions, RouterAction } from 'react-router-redux'
import { connect } from 'react-redux'
import { StickyContainer, Sticky } from 'react-sticky'
import Lightbox from 'react-images-zoom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import '../styles/App.scss'
import '../styles/PublishedJob.scss'
import 'react-perfect-scrollbar/dist/css/styles.css'

import { ListItem } from 'material-ui/List'
import { FlatButton } from 'material-ui'

import { AppBarContainer } from './CustomAppBar'
import * as moment from 'moment'

import {
    JobItems,
    AttachmentParams,
    PublishedJobParams,
    Hauler,
    Fee,
    Job,
    JobCategory,
    AddressInfo,
    ClientInfo,
    LatLng,
    JobPrototype
} from '../types'
import { JobStatus } from '../types/enums'
import { AdditionalItemStatus } from '../types/enums/AdditionalItemStatus'
import { AdditionalItem } from '../types/AdditionalItem'
import { JobCategories } from '../types/jobCategories'

import images from '../images'

import { StarRatings } from '../components/StarRating'
import { DialogBox } from '../components/DialogBox'
import PageTitle from '../components/PageTitle'
import FormattedAddress from '../components/FormattedAddress'
import { LoadingSpinner } from '../components/LoadingSpinner'
import UploadedImages from '../components/UploadedImages'
import JobItemDetails from '../components/JobItemDetails'
import { CustomTextarea } from '../components/CustomTextarea'
import { RescheduleDialog } from '../components/RescheduleDialog'

import { Api } from '../services/api/api'
import { ROUTES } from '../constants/routes'
import { RESCHEDULE } from '../constants/reschedule'

import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import { getFormatedPrice } from '../utils/PricingUtils'

import {
    setJobStatus,
    removeJobDetails,
    statusChangedOnWeb,
    setAdditionalItem,
    setPublishedJobParams,
    setJobId,
    addComment,
    setFutureDateFrom,
    setFutureDateTo,
    setBagsNumber,
    setItemsOutside,
    setItemsInside,
    setAmount,
    setMsaId,
    setElevatorUse,
    setStairsNeeded,
    setAttachments,
    setAddress,
    selectJobCategory,
    setJobCategories,
    setSubCategories,
    reschedule,
    setSelectedJobCategory
} from '../actions/setJobDetails'
import {
    Actions as JobActions,
    ActionType as JobActionType
} from '../actions/job'
import { ActionType as SignInActionType } from '../actions/signIn'
import { ActionType as UserActionType } from '../actions/user'
import { ActionType as ServiceActionType } from '../actions/serviceInfo'

import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { interval } from '../constants/interval'

interface BidAcceptedProps {
    jobDetails: any
    jobItems: JobItems[]
    jobCategoryName: string
    futureDateFrom: number
    futureDateTo: number
    publishedJobParams: PublishedJobParams
    amount: number
    files: AttachmentParams[]
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
    routePush: (location: string) => RouterAction
    bid: any
    onSetJobStatus: (status: string) => void
    onRemoveJobDetails: () => void
    onStatusChangedOnWeb: () => void
    onSetAdditionalItem: (additionalItem: AdditionalItem) => void
    address: any
    additionalItem: AdditionalItem
    pathname: string
    removeJob: () => JobActionType

    setCurrentJobUsed: () => ServiceActionType
    setCurrentLocation: (location: LatLng) => UserActionType
    createJob: (job: JobPrototype) => JobActionType
    updateUser: (client: ClientInfo) => SignInActionType
    onSetJobId: (jobId: string) => void
    onPublishedJobParams: (publishedJobParams: PublishedJobParams) => void

    onAddComment: (event: string) => string
    onSetFutureDateFrom: (futureDateFrom: number) => void
    onSetFutureDateTo: (futureDateTo: number) => void
    onNumberOfBags: (event: any) => any
    onSetItemsOutside: (areItemsOutside: boolean) => void
    onSetItemsInside: (areItemsInside: boolean) => void
    onSetAmount: (amount: number) => void
    onSetMsaId: (msaId: string) => void
    onSetElevatorUse: (isElevatorNeeded: boolean) => void
    onSetStairsNeeded: (areStairsNeeded: boolean) => void
    onSetAttachments: (files: AttachmentParams[] | null) => void
    setAddress: (address?: AddressInfo) => any
    onSelectJobCategory: (name: string, id: string) => void
    onSetJobCategories: (jobCategories: Array<any>) => void
    onSetSubCategories: (subCategories: Array<any>) => void
    reschedule: (isRescheduling: boolean) => void
    onSelectedJobCategory: (selectedJobCategory: string) => void
}

interface BidAcceptedState {
    status: string
    hauler?: Hauler
    isDialogOpen: boolean
    jobStatusinterval?: any
    isCanceledByHauler: boolean
    amount: number
    additionalItem?: AdditionalItem
    isSpinnerShown: boolean
    photoIndex: number
    isImagesBoxOpen: boolean
    files: AttachmentParams[]
    fee?: Fee
    isJobReposted: boolean
    isCanceledByOtherDevice: boolean
    isRescheduleDialogOpen: boolean
}

class BidAcceptedComponent extends React.Component<
    BidAcceptedProps,
    BidAcceptedState
> {
    constructor(props: BidAcceptedProps) {
        super(props)
        this.state = {
            status: this.props.jobDetails.status,
            isDialogOpen: false,
            isCanceledByHauler: false,
            amount: this.props.jobDetails.amount,
            additionalItem: this.props.jobDetails.additionalItem,
            hauler: this.props.jobDetails.hauler,
            isSpinnerShown: false,
            photoIndex: 0,
            isImagesBoxOpen: false,
            files: this.props.files !== null ? this.props.files : [],
            isJobReposted: false,
            isCanceledByOtherDevice: false,
            isRescheduleDialogOpen: false
        }
    }

    componentDidMount() {
        if (this.props.jobDetails.jobId !== '') {
            this.saveJobStatus()
            this.checkJobStatus()
            this.setState({
                files: this.getAllFiles()
            })
        }
        this.setCancellationFee()
    }

    setCancellationFee = () => {
        Api.getFee(this.props.jobDetails.jobId).then((result: Fee) =>
            this.setState({
                fee: result
            })
        )
    }

    componentWillReceiveProps(nextProps: BidAcceptedProps) {
        if (
            this.state.additionalItem &&
            nextProps.additionalItem &&
            this.state.additionalItem.status !== nextProps.additionalItem.status
        ) {
            this.setState({
                additionalItem: nextProps.additionalItem
            })
        }
    }

    saveJobStatus = () => {
        Api.getJob(this.props.jobDetails.jobId)
            .then((job: any) => {
                if (
                    this.state.status !== job.status ||
                    this.state.hauler !== job.hauler ||
                    this.state.amount ||
                    job.amount
                ) {
                    this.setState({
                        status: job.status,
                        hauler: job.hauler,
                        amount: job.amount
                    })
                }
                this.props.onSetJobStatus(job.status)
                return job
            })
            .then(job => {
                let status: string = job.status
                if (
                    status === JobStatus.CANCELLED_BY_HAULER ||
                    status === JobStatus.DECLINED_AUTO ||
                    status === JobStatus.DECLINED_BY_HAULER
                ) {
                    clearInterval(this.state.jobStatusinterval)
                    Api.getActiveJobs().then((result: Array<any>) => {
                        if (result && result.length > 0) {
                            this.setJobDetails(result[0])
                            this.setState({
                                isJobReposted: true,
                                isDialogOpen: true,
                                isCanceledByHauler: true
                            })
                        } else {
                            this.setState({
                                isDialogOpen: true,
                                isCanceledByHauler: true
                            })
                        }
                    })
                } else if (
                    status === JobStatus.CANCELLED_BY_CUSTOMER ||
                    status === JobStatus.DECLINED_BY_CUSTOMER
                ) {
                    clearInterval(this.state.jobStatusinterval)
                    this.props.onRemoveJobDetails()
                    this.props.removeJob()
                    this.setState({
                        isDialogOpen: true,
                        isCanceledByOtherDevice: true
                    })
                } else if (status === JobStatus.COMPLETED) {
                    clearInterval(this.state.jobStatusinterval)
                    this.props.routePush(ROUTES.REVIEW_HAULER)
                } else if (
                    job.additionalItem &&
                    job.additionalItem.status ===
                        AdditionalItemStatus.IN_PROGRESS
                ) {
                    this.props.routePush(ROUTES.ADDITIONAL_ITEMS)
                } else if (
                    job.additionalItem &&
                    (job.additionalItem.status ===
                        AdditionalItemStatus.ACCEPTED ||
                        job.additionalItem.status ===
                            AdditionalItemStatus.CHARGED)
                ) {
                    if (
                        this.state.additionalItem &&
                        this.state.additionalItem.status !==
                            job.additionalItem.status
                    ) {
                        this.props.onSetAdditionalItem(job.additionalItem)
                        this.props.onStatusChangedOnWeb()
                        this.setState({
                            additionalItem: job.additionalItem,
                            files: this.getAllFiles(job.additionalItem)
                        })
                    }
                } else if (status === JobStatus.CREATED) {
                    clearInterval(this.state.jobStatusinterval)
                    this.props.routePush(ROUTES.VIEW_BIDS)
                }
            })
    }

    getAllFiles = (newItem?: AdditionalItem) => {
        let additionalItem: AdditionalItem = newItem
            ? newItem
            : this.props.jobDetails.additionalItem
        let allFiles = this.state.files

        if (
            additionalItem &&
            (additionalItem.status === AdditionalItemStatus.ACCEPTED ||
                additionalItem.status === AdditionalItemStatus.CHARGED) &&
            additionalItem.pictures &&
            additionalItem.pictures
        ) {
            additionalItem.pictures.map(file => {
                let item = allFiles.find(images => images.id === file.id)
                if (!item) {
                    allFiles.push({
                        id: file.id,
                        url: file.url,
                        ownerId: file.ownerId,
                        type: file.type
                    })
                }
            })
        }
        return allFiles
    }

    checkJobStatus = () => {
        let jobStatusinterval = setInterval(
            () => this.saveJobStatus(),
            interval
        )
        this.setState({
            jobStatusinterval: jobStatusinterval
        })
    }

    handleDialogClose = () => {
        this.setState({
            isDialogOpen: false
        })
    }

    // handleRescheduleDialogClose = () => {
    //   this.setState({
    //     isRescheduleDialogOpen: false
    //   })
    // }

    goBack = () => {
        clearInterval(this.state.jobStatusinterval)
        this.props.routePush(ROUTES.PICKUP_LOCATION)
    }

    componentWillUnmount() {
        clearInterval(this.state.jobStatusinterval)
        this.setState({
            isSpinnerShown: false
        })
    }

    // handleRescheduleDialogOpen = () => {
    //   this.setState({
    //     isRescheduleDialogOpen: true
    //   })
    // }

    handleDialogOpen = () => {
        this.setState({
            isDialogOpen: true
        })
    }

    jobCanceledByClient = () => {
        this.setState({
            isSpinnerShown: true,
            // isRescheduleDialogOpen: false
            isDialogOpen: false
        })
        clearInterval(this.state.jobStatusinterval)
        Api.getJob(this.props.jobDetails.jobId)
            .then((job: any) => {
                this.setState({
                    status: job.status
                })
                return job.status
            })
            .then(status => {
                if (
                    status === JobStatus.CREATED ||
                    status === JobStatus.UNDER_REVIEW
                ) {
                    Api.changeStatus(
                        this.props.jobDetails.jobId,
                        JobStatus.CANCELLED_BY_CUSTOMER
                    )
                        .then(() => this.handleDialogClose())
                        .then(() => {
                            this.props.onRemoveJobDetails()
                            this.props.removeJob()
                            this.setState({
                                isSpinnerShown: false
                            })
                            this.props.routePush(ROUTES.PICKUP_LOCATION)
                        })
                        .catch(error => {
                            console.log('can not change job status', error)
                            this.props.onErrorEvent(Mapper.mapError(error))
                        })
                } else {
                    if (
                        status === JobStatus.ACCEPTED ||
                        status === JobStatus.HAULER_ARRIVING ||
                        status === JobStatus.CONFIRM_ARRIVAL ||
                        status ===
                            JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION ||
                        status === 'PAYMENT-ERROR'
                    ) {
                        Api.changeStatus(
                            this.props.jobDetails.jobId,
                            JobStatus.DECLINED_BY_CUSTOMER
                        )
                            .then(() => this.handleDialogClose())
                            .then(() => {
                                this.props.onRemoveJobDetails()
                                this.props.removeJob()
                                this.setState({
                                    isSpinnerShown: false
                                })
                                this.props.routePush(ROUTES.PICKUP_LOCATION)
                            })
                            .catch(error => {
                                console.log('can not change job status', error)
                                this.props.onErrorEvent(Mapper.mapError(error))
                            })
                    } else {
                        this.setState({
                            // isRescheduleDialogOpen: false
                            isDialogOpen: false
                        })
                        this.props.onRemoveJobDetails()
                        this.props.removeJob()
                        this.props.routePush(ROUTES.PICKUP_LOCATION)
                    }
                }
            })
    }

    jobCanceledByHauler = () => {
        clearInterval(this.state.jobStatusinterval)
        this.handleDialogClose()
        this.state.isJobReposted
            ? this.props.routePush(ROUTES.VIEW_BIDS)
            : this.props.routePush(ROUTES.PICKUP_LOCATION)
    }

    handlePlusButtonClick = () => {
        this.props.routePush(ROUTES.ADDITIONAL_ITEMS)
    }

    handleIconClick = (event: any) => {
        // tslint:disable-next-line:radix
        let iconIndex = parseInt(event.target.id)
        this.handleImageClick(iconIndex)
    }

    handleImageClick = (iconIndex: number) => {
        this.setState({ photoIndex: iconIndex, isImagesBoxOpen: true })
    }

    setJobDetails = (job: Job) => {
        let status = job.status
        let hours = Math.floor(job.timeKeeping / 3600000)
        let minutes = Math.floor((job.timeKeeping - hours * 3600000) / 60000)
        let seconds = Math.floor(
            (job.timeKeeping - minutes * 60000 - hours * 3600000) / 1000
        )

        let publishedJobParams = {
            confirmed: true,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            createDate: job.createDate,
            timeKeeping: job.timeKeeping,
            timeStopBidding: job.timeStopBidding,
            secondTimeKeeping: 0,
            biddingActiveDate: 0
        }

        this.props.onSetJobId(job.id)
        this.props.onPublishedJobParams(publishedJobParams)
        this.props.onSetJobStatus(job.status)

        this.props.onAddComment(job.note ? job.note : '')
        this.props.onSetFutureDateFrom(job.futureDateFrom)
        this.props.onSetFutureDateTo(job.futureDateTo)
        this.props.onNumberOfBags(job.jobItems ? job.jobItems : null)
        this.props.onSetItemsOutside(
            job.areItemsOutside ? job.areItemsOutside : false
        )
        this.props.onSetItemsInside(
            job.areItemsInside ? job.areItemsInside : false
        )
        this.props.onSetAmount(job.amount ? job.amount : 0)
        this.props.onSetMsaId(job.msaId ? job.msaId : '')
        this.props.onSetElevatorUse(
            job.isElevatorNeeded ? job.isElevatorNeeded : false
        )
        this.props.onSetStairsNeeded(
            job.areStairsNeeded ? job.areStairsNeeded : false
        )
        this.props.onSetAttachments(job.attachments ? job.attachments : null)
        this.props.setAddress(job.address)

        Api.getCategoriesByZipCode(job.address.zipCode).then(
            (jobCategories: JobCategories[]) => {
                let selectedJobCategory = jobCategories.find(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )
                let index = jobCategories.findIndex(
                    (jobCategory: JobCategory) =>
                        jobCategory.id === job.jobCategoryId
                )

                let jobCategoryName =
                    selectedJobCategory && selectedJobCategory.name
                        ? selectedJobCategory.name
                        : ''
                let jobCategoryId =
                    selectedJobCategory && selectedJobCategory.id
                        ? selectedJobCategory.id
                        : ''
                this.props.onSelectJobCategory(jobCategoryName, jobCategoryId)
                this.props.onSelectedJobCategory(`${index}`)
                this.props.onSetJobCategories(jobCategories)
                this.props.onSetSubCategories(
                    jobCategories[index].subcategories
                )
            }
        )
    }

    setComplimentNumber = () => {
        let complimentsNumber = this.props.jobDetails.complimentsNumber
        let providerId = this.props.jobDetails.providerId
        let providerComplimentNumber
        let randomComplimentNumber

        if (complimentsNumber !== null) {
            let index = complimentsNumber.findIndex(
                item => item.haulerId === providerId
            )!
            randomComplimentNumber = complimentsNumber[index].number
        }

        providerComplimentNumber =
            this.state.hauler &&
            this.state.hauler.numberCompliments &&
            this.state.hauler.numberCompliments !== 0
                ? this.state.hauler.numberCompliments
                : randomComplimentNumber

        return providerComplimentNumber
    }

    // handleReschedule = () => {
    //   this.props.reschedule(true)
    //   this.props.routePush(ROUTES.CONTACT)
    // }

    render() {
        let additionalItemAmount =
            this.props.jobDetails.additionalItem !== null &&
            (this.props.jobDetails.additionalItem.status ===
                AdditionalItemStatus.ACCEPTED ||
                this.props.jobDetails.additionalItem.status ===
                    AdditionalItemStatus.CHARGED)
                ? this.props.jobDetails.additionalItem.amount
                : 0

        let countable =
            this.props.jobDetails.jobCategories.length !== 0 &&
            this.props.jobDetails.selectedJobCategory &&
            this.props.jobDetails.jobCategories[
                this.props.jobDetails.selectedJobCategory
            ].countable

        let jobItems = this.props.jobItems
        let imgSrcs =
            this.state.files &&
            this.state.files.map(file => {
                return { src: file.base64 ? file.base64 : file.url }
            })

        return (
            <BaseContainer pageName={EventType.BID_ACCEPTED}>
                <LoadingSpinner show={this.state.isSpinnerShown} />
                <Lightbox
                    images={imgSrcs ? imgSrcs : []}
                    currentImage={this.state.photoIndex}
                    showImageCount={true}
                    isOpen={this.state.isImagesBoxOpen}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickPrev={() => {
                        this.setState({
                            photoIndex:
                                (this.state.photoIndex +
                                    this.props.files.length -
                                    1) %
                                this.props.files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClickNext={() => {
                        this.setState({
                            photoIndex:
                                (this.state.photoIndex + 1) %
                                this.props.files.length
                        })
                    }}
                    // tslint:disable-next-line:jsx-no-lambda
                    onClose={() => {
                        this.setState({ isImagesBoxOpen: false })
                    }}
                    rotatable={true}
                    zoomable={true}
                />
                <DialogBox
                    isDialogOpen={this.state.isDialogOpen}
                    handleDialogClose={this.handleDialogClose}
                    handleCancel={this.jobCanceledByClient}
                    status={this.state.status}
                    jobCanceledByHauler={this.jobCanceledByHauler}
                    isCanceledByHauler={this.state.isCanceledByHauler}
                    fee={this.state.fee}
                    isJobReposted={this.state.isJobReposted}
                    isCanceledByOtherDevice={this.state.isCanceledByOtherDevice}
                />
                {/* <RescheduleDialog
          isRescheduleDialogOpen={this.state.isRescheduleDialogOpen}
          fee={this.state.fee}
          handleDialogClose={this.handleRescheduleDialogClose}
          handleCancel={this.jobCanceledByClient}
          handleReschedule={this.handleReschedule}
        /> */}
                <AppBarContainer isIconButtonsShown={true} isMenuShown={true} />
                <PageTitle
                    text={
                        this.state.status === JobStatus.ACCEPTED
                            ? StringResources.getString(
                                  Strings.BidAccepted.Titles.jobAwarded
                              )
                            : this.state.status === JobStatus.HAULER_ARRIVING
                            ? StringResources.getString(
                                  Strings.BidAccepted.Titles.providerEnroute
                              )
                            : this.state.status === JobStatus.CONFIRM_ARRIVAL
                            ? StringResources.getString(
                                  Strings.BidAccepted.Titles.providerArrived
                              )
                            : StringResources.getString(
                                  Strings.BidAccepted.Titles.jobAwarded
                              )
                    }
                />
                <PerfectScrollbar className="vertical-scrollbar">
                    <div className="job-details-list">
                        <ListItem
                            className="job-details-list-item provider-info"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="hauler-icon"
                                    src={
                                        this.state.hauler
                                            ? this.state.hauler.avatar
                                            : images.avatar2
                                    }
                                />
                            }
                            primaryText={
                                <div>
                                    {this.state.hauler
                                        ? `${this.state.hauler.firstName} ${this.state.hauler.lastName}`
                                        : ''}
                                    <br />
                                    <p className="company-name">
                                        {this.state.hauler
                                            ? this.state.hauler.companyId
                                            : ''}
                                    </p>
                                </div>
                            }
                            secondaryText={
                                <div className="secondary-text">
                                    <span>
                                        {StringResources.getString(
                                            Strings.BidAccepted.Text
                                                .complimentsReceived
                                        )}{' '}
                                        {this.setComplimentNumber()}
                                        <br />
                                        <StarRatings
                                            initialRating={
                                                this.state.hauler
                                                    ? this.state.hauler
                                                          .starRating
                                                        ? Number(
                                                              this.state.hauler.starRating.toFixed(
                                                                  2
                                                              )
                                                          )
                                                        : 0
                                                    : 0
                                            }
                                            readonly={true}
                                            className="-small"
                                        />
                                    </span>
                                </div>
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="map-icon"
                                    src={images.pickupLocation}
                                />
                            }
                            primaryText="Job Location"
                            secondaryText={
                                <div>
                                    <span>
                                        <FormattedAddress
                                            address={this.props.address}
                                        />
                                    </span>
                                </div>
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            rightAvatar={
                                this.state.additionalItem &&
                                this.state.additionalItem !== null &&
                                (this.state.additionalItem.status ===
                                    AdditionalItemStatus.ACCEPTED ||
                                    this.state.additionalItem.status ===
                                        AdditionalItemStatus.CHARGED) ? (
                                    <img
                                        src={images.plus}
                                        onClick={this.handlePlusButtonClick}
                                        className="right-avatar"
                                    />
                                ) : (
                                    undefined
                                )
                            }
                            leftAvatar={
                                <img
                                    className="job-icon"
                                    src={
                                        this.props.jobCategoryName ===
                                        'Quick Haul'
                                            ? images.quickHaul
                                            : this.props.jobCategoryName ===
                                              'Yard Debris'
                                            ? images.yardDebris
                                            : this.props.jobCategoryName ===
                                              'Junk'
                                            ? images.junk
                                            : this.props.jobCategoryName ===
                                              'Recycle'
                                            ? images.recycle
                                            : images.quickHaul
                                    }
                                />
                            }
                            primaryText={this.props.jobCategoryName}
                            secondaryText={
                                countable ? (
                                    <p>
                                        <span>
                                            {jobItems.map((item, index) => {
                                                return `${
                                                    item.count === 0
                                                        ? ''
                                                        : `${item.count} ${item.subCategoryId}`
                                                }
                            ${
                                item.count !== 0 &&
                                jobItems[index + 1] &&
                                jobItems[index + 1].count !== 0
                                    ? ', '
                                    : ''
                            } `
                                            })}
                                        </span>{' '}
                                        <br />
                                        <span>
                                            {StringResources.getString(
                                                Strings.BidAccepted.Text.price
                                            )}
                                            {additionalItemAmount !== 0
                                                ? getFormatedPrice(
                                                      this.state.amount +
                                                          additionalItemAmount
                                                  )
                                                : getFormatedPrice(
                                                      this.state.amount
                                                  )}
                                        </span>
                                    </p>
                                ) : (
                                    <p className="bid-accepted-attachments">
                                        {StringResources.getString(
                                            Strings.BidAccepted.Text.price
                                        )}
                                        {additionalItemAmount !== 0
                                            ? getFormatedPrice(
                                                  this.state.amount +
                                                      additionalItemAmount
                                              )
                                            : this.state.amount !== null &&
                                              getFormatedPrice(
                                                  this.state.amount
                                              )}
                                    </p>
                                )
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="calendar-icon-published"
                                    src={images.calendar}
                                />
                            }
                            primaryText={StringResources.getString(
                                Strings.BidAccepted.Text.jobTime
                            )}
                            secondaryText={
                                <p>
                                    <span>
                                        {moment(
                                            this.props.futureDateTo
                                        ).day() === moment().day()
                                            ? 'Today: '
                                            : moment(
                                                  this.props.futureDateTo
                                              ).format('MMMM D: ')}
                                        {moment(
                                            this.props.futureDateTo
                                        ).day() === moment().day()
                                            ? moment(
                                                  this.props.futureDateFrom
                                              ).format('h -') +
                                              moment(
                                                  this.props.futureDateTo
                                              ).format(' h a')
                                            : moment(
                                                  this.props.futureDateFrom
                                              ).format('h -') +
                                              moment(
                                                  this.props.futureDateTo
                                              ).format(' h a')}
                                    </span>
                                </p>
                            }
                            secondaryTextLines={2}
                        />
                        <div className="uploaded_img">
                            {!!this.state.files
                                ? this.state.files.map(
                                      (
                                          file: AttachmentParams,
                                          index: number
                                      ) => (
                                          <UploadedImages
                                              key={file.id}
                                              handleIconClick={
                                                  this.handleIconClick
                                              }
                                              file={file}
                                              index={index}
                                              isBadgeNeeded={false}
                                          />
                                      )
                                  )
                                : null}
                        </div>
                        <JobItemDetails
                            areStairsNeeded={
                                this.props.jobDetails.areStairsNeeded
                            }
                            isElevatorNeeded={
                                this.props.jobDetails.isElevatorNeeded
                                    ? true
                                    : false
                            }
                            areItemsOutside={
                                this.props.jobDetails.areItemsOutside
                                    ? true
                                    : false
                            }
                            areItemsInside={
                                this.props.jobDetails.areItemsInside
                                    ? true
                                    : false
                            }
                            pathname={this.props.pathname}
                        />
                        {this.props.jobDetails.note ? (
                            <CustomTextarea
                                text={this.props.jobDetails.note}
                                classes="published-client-comment"
                            />
                        ) : null}
                        <div>
                            <div className="title status">
                                {StringResources.getString(
                                    Strings.BidAccepted.SubTitles.providerStatus
                                )}
                            </div>
                            <ul className="status-emojies">
                                <li>
                                    {this.state.status ===
                                    JobStatus.ACCEPTED ? (
                                        <img
                                            className={'img-active'}
                                            src={images.truck}
                                        />
                                    ) : (
                                        <div className="nonactive" />
                                    )}
                                    <p className="p-active">
                                        {StringResources.getString(
                                            Strings.BidAccepted.JobStatus
                                                .accepted
                                        )}
                                    </p>
                                </li>
                                <li>
                                    {this.state.status ===
                                    JobStatus.HAULER_ARRIVING ? (
                                        <img
                                            className={'img-active'}
                                            src={images.truck}
                                        />
                                    ) : (
                                        <div className="nonactive" />
                                    )}
                                    <p className="p-active">
                                        {StringResources.getString(
                                            Strings.BidAccepted.JobStatus
                                                .onMyWay
                                        )}
                                    </p>
                                </li>
                                <li>
                                    {this.state.status ===
                                    JobStatus.CONFIRM_ARRIVAL ? (
                                        <img
                                            className={'img-active'}
                                            src={images.truck}
                                        />
                                    ) : (
                                        <div className="nonactive" />
                                    )}
                                    <p className="p-active">
                                        {StringResources.getString(
                                            Strings.BidAccepted.JobStatus
                                                .arrived
                                        )}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </PerfectScrollbar>
                <StickyContainer className="sticky-footer">
                    <Sticky>
                        {() => (
                            <div className={'bottom-part hover'}>
                                <FlatButton
                                    label={StringResources.getString(
                                        Strings.BidAccepted.Buttons.Cancel.label
                                    )}
                                    className={
                                        this.state.status ===
                                        JobStatus.CONFIRM_ARRIVAL
                                            ? 'flatbutton next disabled'
                                            : 'flatbutton next'
                                    }
                                    disabled={
                                        this.state.status ===
                                        JobStatus.CONFIRM_ARRIVAL
                                            ? true
                                            : false
                                    }
                                    onClick={this.handleDialogOpen}
                                />
                            </div>
                        )}
                    </Sticky>
                </StickyContainer>
            </BaseContainer>
        )
    }
}
const mapStateToProps = (state: any, ownProps: any) => {
    return {
        jobDetails: state.jobDetails,
        jobItems: state.jobDetails.jobItems,
        futureDateFrom: state.jobDetails.futureDateFrom,
        futureDateTo: state.jobDetails.futureDateTo,
        publishedJobParams: state.publishedJobParams,
        amount: state.jobDetails.amount,
        jobCategoryName: state.jobDetails.jobCategoryName,
        files: state.jobDetails.attachments,
        additionalItem: state.jobDetails.additionalItem
            ? state.jobDetails.additionalItem
            : null,
        address: state.jobDetails.address,
        pathname: state.routing.location.pathname
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        routePush: (location: string) => dispatch(routerActions.push(location)),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo)),
        onSetJobStatus: (status: string) => dispatch(setJobStatus(status)),
        onRemoveJobDetails: () => dispatch(removeJobDetails()),
        removeJob: () => dispatch(JobActions.createJob(null)),
        onSetAdditionalItem: (additionalItem: AdditionalItem) =>
            dispatch(setAdditionalItem(additionalItem)),
        onStatusChangedOnWeb: () => dispatch(statusChangedOnWeb()),

        onPublishedJobParams: (publishedJobParams: PublishedJobParams) =>
            dispatch(setPublishedJobParams(publishedJobParams)),
        onSetJobId: (jobId: string) => dispatch(setJobId(jobId)),
        onAddComment: (note: string) => dispatch(addComment(note)),
        onSetFutureDateFrom: (futureDateFrom: number) =>
            dispatch(setFutureDateFrom(futureDateFrom)),
        onSetFutureDateTo: (futureDateTo: number) =>
            dispatch(setFutureDateTo(futureDateTo)),
        onNumberOfBags: (jobItem: [{ subCategoryId: string; count: number }]) =>
            dispatch(setBagsNumber(jobItem)),
        onSetItemsOutside: (areItemsOutside: boolean) =>
            dispatch(setItemsOutside(areItemsOutside)),
        onSetItemsInside: (areItemsInside: boolean) =>
            dispatch(setItemsInside(areItemsInside)),
        onSetAmount: (amount: number) => dispatch(setAmount(amount)),
        onSetMsaId: (msaId: string) => dispatch(setMsaId(msaId)),
        onSetElevatorUse: (isElevatorNeeded: boolean) =>
            dispatch(setElevatorUse(isElevatorNeeded)),
        onSetStairsNeeded: (areStairsNeeded: boolean) =>
            dispatch(setStairsNeeded(areStairsNeeded)),
        onSetAttachments: (files: Array<any>) =>
            dispatch(setAttachments(files)),
        setAddress: (address?: AddressInfo) => dispatch(setAddress(address)),
        onSetJobCategories: (jobCategories: Array<any>) =>
            dispatch(setJobCategories(jobCategories)),
        onSetSubCategories: (subCategories: Array<any>) =>
            dispatch(setSubCategories(subCategories)),
        onSelectJobCategory: (name: string, id: string) =>
            dispatch(selectJobCategory(name, id)),
        reschedule: (isRescheduling: boolean) =>
            dispatch(reschedule(isRescheduling)),
        onSelectedJobCategory: (selectedJobCategory: string) =>
            dispatch(setSelectedJobCategory(selectedJobCategory))
    }
}
const BidAccepted = connect(
    mapStateToProps,
    mapDispatchToProps
)(BidAcceptedComponent)
export default BidAccepted



// WEBPACK FOOTER //
// ./src/containers/BidAccepted.tsx